import { createErrorWrapper } from '../utils';

export const UPLOAD_ERROR = 'LICENCE.UPDATE_ERROR';
export const DELETE_ERROR = 'LICENCE.DELETE_ERROR';

export const uploadErr = createErrorWrapper(UPLOAD_ERROR, 'Failed to upload licence');
export const deleteErr = createErrorWrapper(DELETE_ERROR, 'Failed to delete licence');
